import { bookingOutcome, isFinalBookingOutcome } from '../../../shared/bookingOutcome'

export function confirmationPresentation(status: { status: string; paymentStatus: string; message?: string }) {
    const outcome = bookingOutcome(status.status, status.paymentStatus)
    const paid = status.paymentStatus === 'paid'
    const refunded = ['refunded', 'partially_refunded'].includes(status.paymentStatus)
    const headings = {
        confirmed: 'BOOKING CONFIRMED',
        pending: 'BOOKING CONFIRMED — PAYMENT PENDING',
        manual_review: paid ? 'PAYMENT RECEIVED' : 'BOOKING NEEDS REVIEW',
        expired: 'BOOKING EXPIRED',
        cancelled: 'BOOKING CANCELLED',
        refunded: 'PAYMENT REFUNDED',
        partially_refunded: 'PAYMENT PARTIALLY REFUNDED',
        unknown: 'BOOKING STATUS UNAVAILABLE',
    }
    const messages = {
        confirmed: 'Thanks—your equipment is booked. Your Stripe receipt will arrive by email.',
        pending: 'Your booking is confirmed, with payment pending. We’re waiting for payment confirmation. Please don’t make another payment.',
        manual_review: paid ? status.message || 'Payment received. Arctic Hire is checking the delivery details.' : 'Arctic Hire needs to check your booking and payment. Please contact us before making another payment.',
        expired: paid ? 'Payment was received, but this checkout is marked as expired. Please contact us so we can check your booking.' : 'This checkout has expired. Please contact us if you still need the equipment or have a question about payment.',
        cancelled: paid ? 'This booking is cancelled, but payment was received. Please contact us about your booking and payment.' : 'This booking has been cancelled. Please contact us if you have a question about your booking or payment.',
        refunded: 'Your payment has been refunded. Please contact us if you have a question about your booking.',
        partially_refunded: 'Part of your payment has been refunded. Please contact us if you have a question about your booking.',
        unknown: 'We can’t confirm the current booking status. Please check again or contact us before making another payment.',
    }
    return {
        outcome,
        final: isFinalBookingOutcome(outcome),
        successfulPayment: paid && (outcome === 'confirmed' || outcome === 'manual_review'),
        heading: headings[outcome],
        title: outcome === 'expired' ? 'Your checkout has expired' : outcome === 'cancelled' ? 'Your booking was cancelled' : outcome === 'unknown' ? 'We’re checking your booking' : 'Thanks for hiring from Arctic Hire',
        message: messages[outcome],
        paymentLabel: paid ? 'Paid' : refunded ? 'Booking total' : outcome === 'pending' ? 'Payment pending' : status.paymentStatus === 'unpaid' ? 'Payment not completed' : 'Payment status unavailable',
    }
}
